import { MasterDataType, PersistDataType, PesistActionType } from "./masterTypes";

export const masterReducer = {
  resetMasterError: (state: MasterDataType) => {
    state.error = null;
  },
  resetMasterSuccess: (state: MasterDataType) => {
    state.success = null;
  },
  resetMasterFetching: (state: MasterDataType) => {
    state.fetching = false;
  },
  resetMasterMessage: (state: MasterDataType) => {
    state.message = "";
  },
  resetMasterStatusCode: (state: MasterDataType) => {
    state.statusCode = null;
  },
  resetMasterDataLisitng: (state: MasterDataType) => {
    state.masterDataListing = [];
  },
  resetMasterDataActivivtyCodeListing: (state: MasterDataType) => {
    state.masterDataActivivtyCodeListing = [];
  },
  resetMasterDataCurrencyListing: (state: MasterDataType) => {
    state.masterDataCurrencyListing = [];
  },
  resetMasterDataBranchListTotal: (state: MasterDataType) => {
    state.masterDataBranchListTotal = "";
  },
  resetMasterDataActivityCodeListTotal: (state: MasterDataType) => {
    state.masterDataActivityCodeListTotal = "";
  },
  resetMasterDataCurrencyListTotal: (state: MasterDataType) => {
    state.masterDataCurrencyListTotal = "";
  },
  resetBranchSuccess: (state: MasterDataType) => {
    state.branchSuccess = null;
  },
  resetBranchSatusCode: (state: MasterDataType) => {
    state.branchSatusCode = null;
  },
  resetBranchError: (state: MasterDataType) => {
    state.branchError = "";
  },
  resetBranchMessage: (state: MasterDataType) => {
    state.branchMessage = "";
  },
  resetIsBranchName: (state: MasterDataType) => {
    state.isBranchName = null;
  },
  resetBranchFetching: (state: MasterDataType) => {
    state.branchFetching = false;
  },
  resetClientGroupList: (state: MasterDataType) => {
    state.clientGroupList = [];
  },
  resetClientGroupTotalCount: (state: MasterDataType) => {
    state.clientGroupTotalCount = 0;
  },
  resetClientGroupUniqueCheckMessage: (state: MasterDataType) => {
    state.clientGroupUniqueCheckMessage = "";
  },
  resetClientGroupUniqueCheckFetching: (state: MasterDataType) => {
    state.clientGroupUniqueCheckFetching = false;
  },
  resetEmailerList: (state: MasterDataType) => {
    state.emailerList = [];
  },
  resetEmailListTotalCount: (state: MasterDataType) => {
    state.emailListTotalCount = 0;
  },
  resetCountryList: (state: MasterDataType) => {
    state.countryList = [];
  },
  resetCountryListTotalCount: (state: MasterDataType) => {
    state.countryListTotalCount = 0;
  },
  resetHolidayCalenderList: (state: MasterDataType) => {
    state.holidayCalenderList = [];
  },
  resetHolidayCalenderTotalCount: (state: MasterDataType) => {
    state.holidayCalenderTotalCount = 0;
  },
  resetStateList: (state: MasterDataType) => {
    state.stateList = [];
  },
  resetStateListTotalCount: (state: MasterDataType) => {
    state.stateListTotalCount = 0;
  },
  resetStateFetching: (state: MasterDataType) => {
    state.stateFetching = false;
  },

  resetCityList: (state: MasterDataType) => {
    state.cityList = [];
  },
  resetCityListTotalCount: (state: MasterDataType) => {
    state.cityListTotalCount = 0;
  },
  resetCityFetching: (state: MasterDataType) => {
    state.cityFetching = false;
  },
  resetStateListAddressPermanent: (state: MasterDataType) => {
    state.stateListPermanentAddress = [];
  },
  resetCityListPermanentAddress: (state: MasterDataType) => {
    state.cityListPermanentAddress = [];
  },

  resetCurrencyExchangeDetails: (state: MasterDataType) => {
    state.currencyExchangeDetails = {
      date: "",
      baseCurrency: "",
      symbol: "",
      rate: "",
    };
  },
  resetClientCategoryList: (state: MasterDataType) => {
    state.clientCategoryList = [];
  },
  resetClientCategoryTotalCount: (state: MasterDataType) => {
    state.clientCategoryTotalCount = 0;
  },
  resetUserDepartmentList: (state: MasterDataType) => {
    state.userDepartmentList = [];
  },
  resetUserDepartmentTotalCount: (state: MasterDataType) => {
    state.userDepartmentTotalCount = 0;
  },
  resetTdsModuleList: (state: MasterDataType) => {
    state.tdsDataList = [];
  },
  resetTotalCount: (state: MasterDataType) => {
    state.totalCount = 0;
  },
  resetTdsSingleData: (state: MasterDataType) => {
    state.tdsSingleData = {};
  },
  resetScopeOfWorkList: (state: MasterDataType) => {
    state.scopeOfWorkList = [];
  },
  resetScopeTotalCount: (state: MasterDataType) => {
    state.scopeOfWorkTotalCount = 0;
  },
  resetSkillMasterDataList: (state: MasterDataType) => {
    state.skillMasterDataList = [];
  },
  resetSkillsMasterDataTotalCount: (state: MasterDataType) => {
    state.skillsMasterDataTotalCount = 0;
  },
  resetQualificationMasterDataList: (state: MasterDataType) => {
    state.qualificationMasterDataList = [];
  },
  resetQualificationMasterDataTotalCount: (state: MasterDataType) => {
    state.qualificationMasterDataTotalCount = 0;
  },
  resetTcsSingleData: (state: MasterDataType) => {
    state.tcsSingleData = {};
  },
  resetTcsModuleList: (state: MasterDataType) => {
    state.tcsDataList = [];
  },
  setPersistApplicationInProgess: (state: MasterDataType, action: PesistActionType) => {
    state.persistApplicationInProgress = action.payload;
  },
  setPersistOfferAccepted: (state: MasterDataType, action: PesistActionType) => {
    state.persistOfferAccepted = action.payload;
  },
  resetCodeFetching: (state: MasterDataType) => { 
    state.codeFetching = false;
  },
  resetCodeError: (state: MasterDataType) => { 
    state.codeError = "";
  },
  resetCodeMessage: (state: MasterDataType) => { 
    state.codeMessage = "";
  },
  resetPdfTemplate: (state: MasterDataType) => { 
    state.pdfTemplateList = [];
  },
  resetPdfTemplateCount: (state: MasterDataType) => { 
    state.pdfTemplateCount = 0;
  },
  resetJobTitleList: (state: MasterDataType) => {
    state.jobTitleList = [];
  },
  resetJobTitleTotalCount: (state: MasterDataType) => {
    state.jobTitleTotalCount = 0;
  }
};
